const ClientsData = [
      {
  "_id": {
    "$oid": "683d815f90754ea1cebceb16"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748861169/sbi_drjmul_e_background_removal_f_png_lnefmk.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d91be90754ea1cebceb58"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748865112/guru-nanak-dev-university_l5xn68.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d91d290754ea1cebceb5a"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748865135/Chandigarh-University-CU_fzhy56.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d921790754ea1cebceb60"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748865289/mc_donald_s_pqlznq.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc476be871937b8142e2b"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748878061/kamboj_hospital_dasirg.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc48abe871937b8142e2f"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754553132/maruti-suzuki-nexa-logo_vg7yi4.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d802090754ea1cebceb12"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748860925/gold_s_gym_qjo9bl_e_background_removal_f_png_l0oho6.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d920890754ea1cebceb5e"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748865307/cheema_sakcza_e_background_removal_f_png_cpq7ta.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc4d7be871937b8142e31"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748878540/adeshlogo_ktpmcw.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "684013ecdc31fbc69322157b"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748859053/E-Max-Group-of-Institutions-Ambala_vbtooq.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "683d91f590754ea1cebceb5c"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748865150/VBL.NS_jcczhe.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc44cbe871937b8142e27"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748878030/stj_groups_cer2ja.webp",
  "__v": 0
},
{
  "_id": {
    "$oid": "6840140edc31fbc69322157d"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748860763/Ivy_Hospital_ndbui4.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc43bbe871937b8142e25"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748877995/vp_broadband_hi1bz4.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc45bbe871937b8142e29"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748878044/Tanishq_faf1zw.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "683dc47fbe871937b8142e2d"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1748878096/affinity_ifjjdv.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "6894594d3a19ec9e961d3bb3"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754552503/acme-logo-vector_yzgxts.png",
  "__v": 0
},
{
  "_id": {
    "$oid": "6894596d3a19ec9e961d3bb5"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754552262/cgc_jkxraa.webp",
  "__v": 0
},
{
  "_id": {
    "$oid": "6894598c3a19ec9e961d3bb7"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754552254/CyberSquare-Mohali_nefinw.jpg",
  "__v": 0
},
{
  "_id": {
    "$oid": "6894599b3a19ec9e961d3bb9"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754552247/DASS_AND_BROWN_raoxmk.webp",
  "__v": 0
},
{
  "_id": {
    "$oid": "689459a63a19ec9e961d3bbb"
  },
  "image": "https://res.cloudinary.com/dzouagfp3/image/upload/v1754552239/HORIZON_butrrb.webp",
  "__v": 0
}]
    
    
    
    export default ClientsData

